import { createAction, props } from '@ngrx/store';
import {
  ILegalEntitiesProductSolutionsManageProductsRequest,
  ILegalEntitiesProductSolutionsManageProductsResponse
} from '../models/product-solutions.model';

export const loadProductSolutions = createAction(
  '[Legal Entities ProductSolution] Load Legal Entities ProductSolutions',
  props<{ request: ILegalEntitiesProductSolutionsManageProductsRequest }>()
);

export const loadProductSolutionsSuccess = createAction(
  '[Legal Entities ProductSolution] Load Legal Entities ProductSolution Success',
  props<{ response: ILegalEntitiesProductSolutionsManageProductsResponse[] }>()
);

export const loadProductSolutionsFailure = createAction(
  '[Legal Entities ProductSolution] Load Legal Entities ProductSolution Failure',
  props<{ error: Error | any }>()
);
